var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPok(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 139,
    height: 64,
    viewBox: "0 0 139 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1885:46080)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.8483 14.3806L36.7488 14.2646C34.537 11.7795 30.9503 10.5701 25.8723 10.5701H5.85065L-1 59.2037H11.8315L13.9107 44.1605H17.9448C23.0144 44.1605 27.2059 43.2658 30.5277 41.576C29.5323 32.059 31.7579 22.4832 36.8483 14.3806ZM17.7377 34.5514H15.2526L17.3401 20.3116H20.5625C24.5967 20.3116 26.6095 22.1258 26.6095 25.6796C26.6095 32.3314 23.3126 34.5514 17.7377 34.5514Z",
    fill: "#07074E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.179 10.5701H125.807L106.929 30.3184L109.687 10.5701H96.8555V10.6363C99.4183 15.6515 100.694 21.2252 100.567 26.8558C100.73 36.7799 97.2398 46.4179 90.7588 53.9353L90.0132 59.2037H102.845L104.858 44.964L110.234 39.7867L118.02 59.2037H132.335L120.572 30.9231L140.179 10.5701Z",
    fill: "#07074E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.5741 7.4388C84.9684 2.46858 78.499 -0.0165398 70.2567 -0.0165398C65.4873 -0.088317 60.7563 0.845324 56.3717 2.7236C51.9872 4.60187 48.0475 7.38258 44.8091 10.8848C41.409 14.3423 38.733 18.4436 36.9379 22.9484C35.1429 27.4532 34.2647 32.2709 34.3549 37.1193C34.3549 45.1877 36.6579 51.6573 41.2636 56.6275C45.8694 61.5978 52.3471 63.9835 60.5894 63.9835C65.3585 64.0561 70.0892 63.122 74.4727 61.2421C78.8563 59.3622 82.794 56.5789 86.0287 53.0738C89.4303 49.6169 92.1078 45.5159 93.9043 41.0111C95.7008 36.5063 96.5803 31.6882 96.4911 26.8392C96.4911 18.7819 94.1854 12.3152 89.5741 7.4388ZM76.1048 44.7652C74.4745 46.9279 72.3554 48.6738 69.9207 49.8602C67.4861 51.0466 64.805 51.6397 62.0971 51.591C54.0288 51.591 49.2408 45.5605 49.2408 36.3407C49.2408 29.5149 51.0135 23.8405 54.6501 19.3176C56.2683 17.1362 58.383 15.3717 60.819 14.1703C63.2549 12.9689 65.942 12.3652 68.6578 12.409C76.8089 12.409 81.597 18.4313 81.597 27.6511C81.597 34.4769 79.7082 40.1511 76.1048 44.7652Z",
    fill: "#7570FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1885:46080"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 141.171,
    height: 64,
    fill: "white",
    transform: "translate(-1)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPok);
export default __webpack_public_path__ + "static/media/POK.b748596fdb759eaa4d8ffec95bef1457.svg";
export { ForwardRef as ReactComponent };